module.exports = __webpack_public_path__ + "/images/ico-cover-add-success.96b722b.svg";